import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';

import { ImportLineup } from '@sorare/gameplay/src/components/importLineup/ImportLineup';

const Relative = styled.div`
  position: relative;
  isolation: isolate;
`;
const PlayProLayout = () => {
  return (
    <Relative>
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
        <ImportLineup />
      </Suspense>
    </Relative>
  );
};

export default PlayProLayout;
